import { render, staticRenderFns } from "./TransferDetailView.vue?vue&type=template&id=ef91e3dc"
import script from "./TransferDetailView.vue?vue&type=script&lang=js"
export * from "./TransferDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports